import { baseApi, ENDPOINTS } from '@/shared/api';

import type { Viewer } from '../model/types/viewer';

const viewerApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['ViewerData'] })
    .injectEndpoints({
        endpoints: (build) => ({
            getMe: build.query<Viewer, void>({
                query: () => ENDPOINTS.viewer.me,
                providesTags: ['ViewerData'],
            }),
        }),
    });

export const getMeQuery = viewerApi.endpoints.getMe.initiate;

export const getMeFulfilledMatcher = viewerApi.endpoints.getMe.matchFulfilled;
